import React from 'react';

import { VerificationRequestType } from 'src/api';

import { DEFAULT_PDF_SHOW } from './constants';
import { EmployeeMyVerifyFormForAnotherRequest } from './EmployeeMyVerifyFormForAnotherRequest';
import { EmployeeMyVerifyFormForRequest } from './EmployeeMyVerifyFormForRequest';
import { StatusForm } from './types';

export const EmployeeMyVerifyForm: React.FC = () => {
  const [verificationType, setVerificationType] =
    React.useState<VerificationRequestType>(DEFAULT_PDF_SHOW);
  const [statusForm, setStatusForm] = React.useState<StatusForm>(StatusForm.request);

  switch (statusForm) {
    case StatusForm.anotherRequest:
      return (
        <EmployeeMyVerifyFormForAnotherRequest
          verificationType={verificationType}
          setVerificationType={setVerificationType}
          setStatusForm={setStatusForm}
        />
      );
    case StatusForm.request:
      return (
        <EmployeeMyVerifyFormForRequest
          setStatusForm={setStatusForm}
          verificationType={verificationType}
          setVerificationType={setVerificationType}
        />
      );
    default:
      return null;
  }
};
